/* eslint-disable comma-dangle */
/* eslint-disable quotes */

import { LlmMockThread } from '@websolutespa/bom-mixer-llm';

export const thread: LlmMockThread = [
  {
    "role": "user",
    "chunks": [
      "elementi custom\n",
    ],
    "createdAt": "2025-07-07T12:00:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Se cerchi pasta corta, nella nostra selezione trovi tanti formati diversi, ciascuno con una personalità precisa in cucina. Ti segnalo alcuni dei nostri formati più apprezzati:\n",
      {
        "type": "customCardItem",
        "id": "xxxxxx-1",
        "title": "Fusilli Corti Bucati n° 198",
        "media": {
          "type": "image",
          "url": "https://www.dececco.com/wp-content/themes/dececco/dist/img/packOver/QSX0188-TROFIE-1.png"
        },
        "href": "/"
      },
      {
        "type": "customCardItem",
        "id": "xxxxxx-2",
        "title": "Fusilli Corti Bucati n° 198",
        "media": {
          "type": "image",
          "url": "https://www.dececco.com/wp-content/themes/dececco/dist/img/packOver/QSX0188-TROFIE-1.png"
        },
        "href": "/"
      },
      {
        "type": "customCardItem",
        "id": "xxxxxx-2",
        "title": "Fusilli Corti Bucati n° 198",
        "media": {
          "type": "image",
          "url": "https://www.dececco.com/wp-content/themes/dececco/dist/img/packOver/QSX0188-TROFIE-1.png"
        },
        "href": "/"
      },
      {
        "type": "customCardItem",
        "id": "xxxxxx-2",
        "title": "Fusilli Corti Bucati n° 198",
        "media": {
          "type": "image",
          "url": "https://www.dececco.com/wp-content/themes/dececco/dist/img/packOver/QSX0188-TROFIE-1.png"
        },
        "href": "/"
      },
      {
        "type": "customCardItem",
        "id": "xxxxxx-2",
        "title": "Fusilli Corti Bucati n° 198",
        "media": {
          "type": "image",
          "url": "https://www.dececco.com/wp-content/themes/dececco/dist/img/packOver/QSX0188-TROFIE-1.png"
        },
        "href": "/"
      }
    ],
    "createdAt": "2025-07-07T12:03:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "elementi custom\n",
    ],
    "createdAt": "2025-07-07T12:02:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Se cerchi pasta corta, nella nostra selezione trovi tanti formati diversi, ciascuno con una personalità precisa in cucina. Ti segnalo alcuni dei nostri formati più apprezzati:\n",
      {
        "type": "customCard",
        "id": "xxxxxx-1",
        "title": "Fusilli Corti Bucati n° 198",
        "media": {
          "type": "image",
          "url": "https://www.dececco.com/wp-content/themes/dececco/dist/img/packOver/QSX0188-TROFIE-1.png"
        },
        "href": "/"
      }
    ],
    "createdAt": "2025-07-07T12:01:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "Ciao\n"
    ],
    "createdAt": "2025-07-07T12:00:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Ciao!\n\n",
      "come posso aiutarti?\n\n"
    ],
    "createdAt": "2025-07-07T12:17:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "markdown\n",
    ],
    "createdAt": "2025-07-07T12:16:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Markdown\n",
      "  \n",
      "Header 1  \n========  \n",
      "  \n",
      "Header 2  \n--------  \n",
      "  \n",
      "### Header 3 ###  \n",
      "#### Header 4 ####  \n",
      "##### Header 5 #####  \n",
      "###### Header 6 ######   \n",
      "  \n",
      "### Phrase Emphasis   \n",
      "  \n",
      "*italic*   \n",
      "**bold**  \n",
      "_italic_   \n",
      "__bold__  \n",
      "  \n",
      "### Links  \n",
      "  \n",
      "An [example](https://www.gmail.com/ \"Title\")  \n",
      "  \n",
      "### Images  \n",
      "![alt text](https://picsum.photos/id/104/800/600 \"Title\")  \n",
      "  \n",
      "### Lists  \n",
      "  \n",
      "1.  Foo  \n",
      "2.  Bar  \n",
      "  \n",
      "*   A list item.  \n",
      "    With multiple paragraphs.  \n",
      "*   Bar  \n",
      "*   Abacus  \n",
      "    * answer  \n",
      "*   Bubbles  \n",
      "    1.  bunk  \n",
      "    2.  bupkis  \n",
      "        * BELITTLER  \n",
      "    3. burper  \n",
      "*   Cunning  \n",
      "  \n",
      "### Blockquotes  \n",
      "> Email-style angle brackets  \n",
      "> are used for blockquotes.  \n",
      "  \n",
      "> > And, they can be nested.  \n",
      "  \n",
      "> ### Headers in blockquotes  \n",
      ">   \n",
      "> * You can quote a list.  \n",
      "> * Etc.  \n",
      "  \n",
      "### Code Spans  \n",
      "`<code>` spans are delimited by backticks.  \n",
      "  \n",
      "You can include literal backticks like `` `this` ``.  \n",
      "  \n",
      "### Preformatted Code Blocks  \n",
      "  \n",
      "This is a normal paragraph.  \n",
      "  \n",
      "    This is a preformatted  \n",
      "    code block.  \n",
      "  \n",
      "```  \n",
      "function sum(a, b) {  \n",
      "  return a + b;  \n",
      "}  \n",
      "```  \n",
      "  \n",
      "### Horizontal Rules  \n",
      "  \n",
      "---  \n",
      "  \n",
      "* * *  \n",
      "  \n",
      "- - - -   \n",
      "  \n",
      "### Manual Line Breaks  \n",
      "  \n",
      "Roses are red,   \n",
      "Violets are blue.  \n",
      "  \n"
    ],
    "createdAt": "2025-07-07T12:17:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "products\n",
    ],
    "createdAt": "2025-07-07T12:04:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Products:\n",
      {
        "type": "productItem",
        "id": "54792",
        "productType": "simple",
        "sku": "K18090",
        "currency": "EUR",
        "price": "1.370000",
        "priceLabel": "1,37€ al pubblico",
        "title": "CAPPELLINO ZUCCOTTO DOPPIO STRATO IN ACRILICO MIMETICO",
        "media": {
          "type": "image",
          "src": "https://www.siliconsrl.it/media/catalog/product/cache/95f6a12655416b1764261bf00237b0fc/k/1/k18090.jpg"
        },
        "url": "https://www.siliconsrl.it/it/k18090-cappellino-zuccotto-doppio-strato-in-acrilico-mimetico",
        "availability": "87",
        "label": "Outlet"
      },
      {
        "type": "productItem",
        "id": "54617",
        "productType": "configurable",
        "sku": "K18053",
        "currency": "EUR", "price": "20.880000",
        "priceLabel": "20,88€ al pubblico",
        "title": "CAPPELLINO 6 PANNELLI SPORTY",
        "abstract": "in cotone pesante pettinato con ricamo sulla visiera e sui pannelli laterali, chiusura regolabile con velcro.",
        "media": {
          "type": "image",
          "src": "https://www.siliconsrl.it/media/catalog/product/cache/95f6a12655416b1764261bf00237b0fc/k/1/k18053bl_1.jpg"
        },
        "url": "https://www.siliconsrl.it/it/k18053-cappellino-6-pannelli-sporty",
        "availability": "54",
        "label": "Outlet"
      },
      {
        "type": "productItem",
        "id": "58216",
        "productType": "configurable",
        "sku": "K18118",
        "currency": "EUR", "price": "21.060000",
        "priceLabel": "21,06€ al pubblico",
        "title": "CAPPELLINO MIRAMARE IN 100% COTONE",
        "abstract": "in twill di cotone 16x12 di buona qualità.",
        "media": {
          "type": "image",
          "src": "https://www.siliconsrl.it/media/catalog/product/cache/95f6a12655416b1764261bf00237b0fc/k/1/k18118b.jpg"
        },
        "url": "https://www.siliconsrl.it/it/k18118-cappellino-da-pescatore-a-falda-in-100-cotone",
        "availability": "102",
        "label": "Bestseller"
      },
      "Vuoi esplorare altre categorie di prodotti? Ecco alcune opzioni che potrebbero interessarti:\n",
      "<div class=\"llm__pill\">Scrittura</div>\n",
      "<div class=\"llm__pill\">Ufficio</div>\n",
      "<div class=\"llm__pill\">Tecnologia</div>\n"
    ],
    "createdAt": "2025-07-07T12:05:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "events\n",
    ],
    "createdAt": "2025-07-07T12:06:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Fammi pensare...\n",
      "ecco una lista di eventi:\n",
      {
        "type": "eventItem",
        "id": "xxxx",
        "title": "Percorri la Bicipolitana di Pesaro con i tuoi bambini",
        "abstract": "Un’esperienza da non perdere se visiterai la città con i bambini, noleggia la tua bici e esplora Pesaro.",
        "place": "Pesaro",
        "url": "https://design.wslabs.it/llm",
        "image": "https://design.wslabs.it/llm/default/bicipolitana.jpg",
        "date": "15-16 giugno 2024",
        "time": "ore 20:00",
      },
      {
        "type": "eventItem",
        "id": "100",
        "title": "Non perderti The Magic Castle di Gradara!",
        "abstract": "The Magic Castle, l’evento per famiglie che ogni estate trasforma magicamente lo splendido borgo di Gradara.",
        "place": "Gradara",
        "url": "https://design.wslabs.it/llm",
        "image": "https://design.wslabs.it/llm/default/gradara.jpg",
        "date": "15-16 giugno 2024",
        "time": "ore 20:00",
      },
      {
        "type": "eventItem",
        "id": "xxxx",
        "title": "Trekking e panorami mozzafiato al San Bartolo",
        "abstract": "Scendendo lungo la costa Adriatica, si erge il San Bartolo, un meraviglioso parco naturale affacciato sul mare.",
        "place": "Parco San Bartolo",
        "url": "https://design.wslabs.it/llm",
        "image": "https://design.wslabs.it/llm/default/san-bartolo.jpg",
        "date": "15-16 giugno 2024",
        "time": "ore 20:00",
      },
      "Per qualunque altra cosa sono qui. 🙂\n",
    ],
    "createdAt": "2025-07-07T12:07:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "event\n",
    ],
    "createdAt": "2025-07-07T12:08:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Dammi un momento...\n",
      "ecco un evento:\n",
      {
        "type": "event",
        "id": "234",
        "title": "Rossini Virtual 'Experience': esplora casa Rossini in AR",
        "abstract": "Lasciati guidare dallo stesso Gioacchino nella sua casa e scopri la sua storia attraverso giocosi aneddoti in AR.",
        "place": "Pesaro",
        "url": "https://design.wslabs.it/llm",
        "image": "https://picsum.photos/id/103/800/600",
        "date": "15-16 giugno 2024",
        "time": "ore 20:00",
      },
      "Serve altro?\n",
    ],
    "createdAt": "2025-07-07T12:09:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "pois\n",
    ],
    "createdAt": "2025-07-07T12:10:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Bene!\n",
      "ecco alcuni punti di interesse:\n",
      {
        "type": "poiItem",
        "id": "111",
        "title": "Title",
        "abstract": "Lorem ipsum dolor sit amet.",
        "place": "Place",
        "image": "https://picsum.photos/id/102/800/600",
        "url": "https://design.wslabs.it/llm",
        "time": "time",
      },
      {
        "type": "poiItem",
        "id": "222",
        "title": "Title",
        "abstract": "Lorem ipsum dolor sit amet.",
        "place": "Place",
        "image": "https://picsum.photos/id/101/800/600",
        "url": "https://design.wslabs.it/llm",
      },
      "Serve altro? 🙂\n",
    ],
    "createdAt": "2025-07-07T12:11:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "poi\n",
    ],
    "createdAt": "2025-07-07T12:12:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Certo!\n",
      "ecco un punto di interesse:\n",
      {
        "type": "poiItem",
        "id": "111",
        "title": "Title",
        "abstract": "Lorem ipsum dolor sit amet.",
        "place": "Place",
        "image": "https://design.wslabs.it/llm/default/rossini.jpg",
        "url": "https://design.wslabs.it/llm",
        "time": "time",
      },
      "Serve altro? 🙂\n",
    ],
    "createdAt": "2025-07-07T12:13:00.000Z"
  },
  {
    "role": "user",
    "chunks": [
      "tripadvisor\n",
    ],
    "createdAt": "2025-07-07T12:14:00.000Z"
  },
  {
    "role": "assistant",
    "chunks": [
      "Dammi un secondo...\n",
      "ecco alcuni ristoranti per te:\n",
      {
        "type": "tripadvisor",
        "id": "xxxx",
        "title": "L'Angolo di Mario",
        "rating": 4.8,
        "reviews": 2276,
        "priceRange": "€€-€€€",
        "cuisine": "Italiana, Pesce, Mediterranea",
        "address": "Via Nazario Sauro, 61100 Pesaro PU",
        "url": "https://design.wslabs.it/llm",
        "book": "https://design.wslabs.it/llm",
        "image": "https://design.wslabs.it/llm/default/tripadvisor-01.jpg",
      },
      {
        "type": "tripadvisor",
        "id": "xxxx",
        "title": "L'Amo Osteria di Mare",
        "rating": 4.2,
        "reviews": 287,
        "priceRange": "€€-€€€",
        "cuisine": "Italiana, Pesce, Mediterranea",
        "address": "Via Venturini 4/6, 61121 Pesaro PU",
        "url": "https://design.wslabs.it/llm",
        "book": "https://design.wslabs.it/llm",
        "image": "https://design.wslabs.it/llm/default/tripadvisor-02.jpg",
      },
    ],
    "createdAt": "2025-07-07T12:15:00.000Z"
  }
];
